<template>
    <div class="course info-box is-card">
        <div class="box-main">
            <div class="box-icon is-hidden-touch">
                <i class="fad fa-browsers has-text-primary fa-2x"></i>
            </div>
            <div class="box-body">
                <div class="card-title">
                    <i class="fad fa-browsers has-text-primary is-hidden-desktop mr-2"></i>{{ course.title }}
                </div>
                <div class="card-meta" v-if="course.organization">{{ course.organization.title }}</div>

                <div class="card-chips mt-2" v-if="chips.length">
                    <status-chip v-for="chip in chips" :key="chip.label" :label="chip.label" :type="chip.type" :icon="chip.icon"/>
                </div>
            </div>
        </div>

        <!-- Already enrolled: say so, and whether another enrollment is allowed -->
        <div class="box-alert" v-if="course.enrolled">
            <i class="fas fa-fw fa-circle-info mr-2"></i>You are already enrolled in this course.<template v-if="course.repeatBlocked"> The enrollment limit for this course has been reached.</template><template v-else> You may enroll again.</template>
        </div>

        <div class="box-actions">
            <div class="box-buttons">
                <b-button v-if="course.enrolled" tag="router-link" :to="{name: 'enrollments'}" type="is-primary" outlined size="is-small"><i class="fas fa-chalkboard-teacher mr-2"></i>View Enrollment</b-button>
                <!-- Enrolled courses stay enrollable while their repeat-enrollment limit has room -->
                <b-button type="is-primary" size="is-small" @click="$emit('enroll', course)" :disabled="course.repeatBlocked || course.processing">
                    <span v-if="!course.processing"><i class="fas fa-pencil mr-2"></i>Enroll</span>
                    <span v-else><i class="fas fa-spinner fa-spin mr-2"></i>Enrolling</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import StatusChip from "./framework/StatusChip";

    /**
     * Course catalog card (global .info-box.is-card anatomy). The hour tiers
     * come from the course's live configs (price and term are deliberately
     * left to checkout); the Enroll button hands off to the catalog page,
     * which routes into checkout.
     */
    export default {
        name: "CatalogCourse",
        components: {StatusChip},
        props: ['course', 'details'],
        computed: {
            liveConfigs() {
                return (this.course.configs || []).filter(c => c.is_enabled !== false && !c.is_hidden && !c.is_deleted);
            },
            // Courses are sold in hour tiers (10, 20 … 50); show the span
            hoursRange() {
                const units = this.liveConfigs.map(c => parseInt(c.units, 10)).filter(n => n > 0);
                return units.length ? [Math.min(...units), Math.max(...units)] : null;
            },
            chips() {
                const out = [];
                if (this.hoursRange) {
                    const [lo, hi] = this.hoursRange;
                    out.push({label: lo === hi ? `${hi} hour${hi === 1 ? '' : 's'}` : `${lo}–${hi} hours`, type: 'info', icon: 'fa-clock'});
                }
                if (this.course.enrolled) out.push({label: 'Enrolled', type: 'success', icon: 'fa-circle-check'});
                return out;
            }
        }
    };
</script>

<style lang="scss" scoped>
    // Layout comes from the global .info-box.is-card (assets/scss/_cta.scss)
    .card-title {
        font-weight: 700;
        line-height: 1.3;
    }

    .card-meta {
        font-size: 0.85rem;
        color: #7a7a7a;
    }

    .card-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 0.4rem;
    }
</style>
